// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1LwUCUcrfcssIvaL1Cn80c {\n  cursor: pointer;\n}", ""]);
// Exports
exports.locals = {
	"action": "_1LwUCUcrfcssIvaL1Cn80c"
};
module.exports = exports;
